/* eslint-disable no-console */
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useUserInput } from '@store';

interface CostSummaryResources {
	titleAllMethods: string;
	titleAtmMbway: string;
	solutionIntegrated: {
		commissions: string;
		paymentTax: string;
		paymentTaxLink: string;
		paymentTaxUrl: string;
	};
	noSolutionIntegrated: {
		paymentTax: string;
		paymentTaxLink: string;
		paymentTaxUrl: string;
		solutionMCorporate: string;
		solutionMCorporateLink: string;
		solutionMCorporateUrl: string;
	};
	iconMbway: string;
	iconAtm: string;
	iconVisa: string;
	iconMastercard: string;
	valueWithoutPromotion: string;
	valueWithPromotion: string;
}
interface CostSummaryHelperOutput {
	resources: CostSummaryResources;
	titleLabel: string;
	acceptMasterOrVisaCards: boolean;
	solutionIntegrated: boolean;
	selectedAccountIntegratedSolution: boolean;
}

export const useCostSummaryHelper = (): CostSummaryHelperOutput => {
	const t = useTranslation();
	const { acceptMasterOrVisaCards, solutionIntegrated, selectedAccount } = useUserInput();

	const resources: CostSummaryResources = {
		titleAllMethods: t('placeholder.costSummary.title.allMethods'),
		titleAtmMbway: t('placeholder.costSummary.title.atmMbway'),
		solutionIntegrated: {
			commissions: t('general.solutionIntegrated.commissions.text'),
			paymentTax: t('general.solutionIntegrated.paymentTax.text'),
			paymentTaxLink: t('general.solutionIntegrated.paymentTax.link'),
			paymentTaxUrl: t('placeholders.solutionIntegrated.paymentTax.url'),
		},
		noSolutionIntegrated: {
			paymentTax: t('general.noSolutionIntegrated.paymentTax.text'),
			paymentTaxLink: t('general.noSolutionIntegrated.paymentTax.link'),
			paymentTaxUrl: t('placeholders.noSolutionIntegrated.paymentTax.url'),
			solutionMCorporate: t('general.noSolutionIntegrated.solutionMCorporate.text'),
			solutionMCorporateLink: t('general.noSolutionIntegrated.solutionMCorporate.link'),
			solutionMCorporateUrl: t('placeholders.noSolutionIntegrated.solutionMCorporate.url'),
		},
		iconMbway: t('placeholder.costSummary.icon.mbway'),
		iconAtm: t('placeholder.costSummary.icon.atm'),
		iconVisa: t('placeholder.costSummary.icon.visa'),
		iconMastercard: t('placeholder.costSummary.icon.mastercard'),
		valueWithoutPromotion: t('general.valueWithoutPromotion'),
		valueWithPromotion: t('general.valueWithPromotion'),
	};

	const titleLabel = acceptMasterOrVisaCards ? resources.titleAllMethods : resources.titleAtmMbway;

	return {
		resources,
		titleLabel,
		acceptMasterOrVisaCards: acceptMasterOrVisaCards !== undefined ? acceptMasterOrVisaCards : false,
		solutionIntegrated: solutionIntegrated !== undefined ? solutionIntegrated : false,
		selectedAccountIntegratedSolution: selectedAccount?.account.integratedSolution ?? false,
	};
};
